import React from "react";
import countriesByCode from "./countriesByCode.json";
import { cellErrors } from "@/react/components/table/useTableMutations";
import { useRetrieveDmsCountriesQuery } from "@/react/features/smp/dms/didApi";
import Select from "@8x8/oxygen-select";
import useEditableCell from "@/react/components/table/useEditableCell";
import schema, {
  thirdPartyMap,
} from "@/react/features/vcc/sms-channels/schema";
import { isColumnSetter } from "@/react/components/table/columns";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import { ValidationWrapper } from "@/react/components/table/components";

export function CountrySelectorCell(countryCodeCell) {
  const cellIsColumnSetter = isColumnSetter(countryCodeCell);
  const { value, onChange, onBlur } = useEditableCell(countryCodeCell);

  const errors = cellErrors(countryCodeCell);

  const { data: countryCodes, isFetching: isFetchingCountries } =
    useRetrieveDmsCountriesQuery();

  const thirdPartyCell = countryCodeCell.row
    ?.getAllCells()
    .find((c) => c.column.id === schema.fields.thirdParty.spec.key)
    ?.getContext();

  const isManualPhoneNumberEntry =
    [thirdPartyMap.TWILIO, thirdPartyMap.WAVECELL].includes(
      thirdPartyCell?.getValue()
    ) || cellIsColumnSetter;

  const options = (countryCodes || [])?.map((countryCode) => ({
    value: countryCode,
    label: countriesByCode[countryCode]?.name || countryCode,
  }));

  const selectedValue = options.find((option) => option.value === value);

  return (
    <FullWidthDiv>
      <ValidationWrapper errors={errors}>
        <Select
          size={"small"}
          testId={"country-select"}
          isDisabled={isFetchingCountries || !isManualPhoneNumberEntry}
          options={options}
          value={selectedValue}
          onChange={(opt) => onChange(opt?.value)}
          onBlur={onBlur}
          hasError={errors.length > 0}
          isClearable={true}
          isSearchable={true}
          placeholder={`Select the phone number country`}
        />
      </ValidationWrapper>
    </FullWidthDiv>
  );
}
